const PROTOTYPE_LIST = [
  'null',
  'undefined',
  'boolean',
  'string',
  'symbol',
  'number',
  'bigint',
  'record',
  'array',
  'map',
  'set',
  'date',
  'regexp',
  'error',
  'arraybuffer',
  'sharedarraybuffer',
  'dataview',
  'int8array',
  'uint8array',
  'uint8clampedarray',
  'int16array',
  'uint16array',
  'int32array',
  'uint32array',
  'float32array',
  'float64array',
  'bigint64array',
  'biguint64array',
  'url',
  'urlsearchparams',
  'blob',
  'file',
  'unknown',
]

/**
 * Represents the normalized runtime tag returned by {@link prototype}.
 */
export type Prototype = (typeof PROTOTYPE_LIST)[number]

/**
 * Returns a normalized lowercase tag for the runtime category of `value`.
 *
 * Primitive values are classified with `typeof`. Objects and built-in platform
 * values are classified with `Object.prototype.toString`.
 *
 * @param value The value to classify.
 * @returns A normalized runtime tag such as `"string"`, `"record"`, `"url"`, or `"unknown"`.
 */
export function prototype(value: unknown): Prototype {
  let type: string = typeof value

  if (type === 'object') {
    type = Object.prototype.toString.call(value).slice(8, -1).toLowerCase()
  }

  if (type === 'object') type = 'record'

  if (!PROTOTYPE_LIST.includes(type as Prototype)) {
    type = 'unknown'
  }

  return type as Prototype
}
